import {
  collectionGroup,
  documentId,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";

const buildEventResult = (docSnap) => {
  const pathParts = docSnap.ref.path.split("/");

  return {
    event: { id: docSnap.id, ...docSnap.data() },
    userId: pathParts[1],
    eventId: pathParts[3],
  };
};

export const findEventByCodeOrSlug = async (codeOrSlug) => {
  const shortCodeQuery = query(
    collectionGroup(db, "events"),
    where("shortCode", "==", codeOrSlug)
  );
  const shortCodeSnap = await getDocs(shortCodeQuery);

  if (!shortCodeSnap.empty) {
    return buildEventResult(shortCodeSnap.docs[0]);
  }

  const slugQuery = query(
    collectionGroup(db, "events"),
    where("customSlug", "==", codeOrSlug)
  );
  const slugSnap = await getDocs(slugQuery);

  if (!slugSnap.empty) {
    return buildEventResult(slugSnap.docs[0]);
  }

  try {
    const eventIdQuery = query(
      collectionGroup(db, "events"),
      where(documentId(), "==", codeOrSlug)
    );
    const eventIdSnap = await getDocs(eventIdQuery);

    if (!eventIdSnap.empty) {
      return buildEventResult(eventIdSnap.docs[0]);
    }
  } catch (err) {
    console.warn("Could not resolve event by document id.", err);
  }

  return null;
};

export const slugifyEventValue = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 48);

export const getEventPublicCode = (event, preferredCode = "") =>
  preferredCode || event?.customSlug || event?.shortCode || event?.id;
